import { NestedFilter, GQL_ID } from '@@partner:types:graphql'
import { makeBetweenFilter, makeFilter } from './crud/filters'

export type CourierWorkShiftFiltersType = {
  dateRange?: [Date, Date] | null
  courierIds: GQL_ID[]
  shopIds: GQL_ID[]
  status: number[]
  vehicleIds: GQL_ID[]
  vehicleTypeIds: string[]
}

export const prepareCourierWorkShiftFilter = (filters: CourierWorkShiftFiltersType): NestedFilter => {
  // Фильтр по дате планируемого начала (plannedStartAt -> ts_starting)
  const dateFilter = makeBetweenFilter('ts_starting', {
    from: filters.dateRange?.[0].getTime(),
    to: filters.dateRange?.[1].getTime()
  })

  // Фильтр по курьеру
  const courierFilter = makeFilter('courier_id', 'contains', filters.courierIds)

  // Фильтр по магазину (через связь с курьером)
  const shopFilter = makeFilter('shop_id', 'contains', filters.shopIds)

  // Фильтр по статусу
  const statusFilter = makeFilter('status', 'contains', filters.status)

  // Фильтр по транспортному средству
  const vehicleFilter = makeFilter('vehicle_id', 'contains', filters.vehicleIds)

  // Фильтр по типу транспортного средства (через связь)
  const vehicleTypeFilter = makeFilter('vehicle.type_id', 'contains', filters.vehicleTypeIds)

  return {
    and: [
      dateFilter,
      courierFilter,
      shopFilter,
      statusFilter,
      vehicleFilter,
      vehicleTypeFilter
    ]
  }
}
